"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ExportCompanyMeetingsMetadataSchema () {
        return ExportCompanyMeetingsMetadataSchema;
    },
    get ExportWorkspaceMeetingsMetadataSchema () {
        return ExportWorkspaceMeetingsMetadataSchema;
    },
    get GenerateReviewCycleInsightsMetadataSchema () {
        return GenerateReviewCycleInsightsMetadataSchema;
    },
    get getMetadataSchemaForTask () {
        return getMetadataSchemaForTask;
    }
});
const _zod = require("zod");
const _model = require("./model");
const ExportCompanyMeetingsMetadataSchema = _zod.z.object({
    filters: _zod.z.record(_zod.z.unknown()).optional(),
    sort: _zod.z.object({
        name: _zod.z.string(),
        direction: _zod.z.enum([
            "asc",
            "desc"
        ])
    }).optional(),
    timezone: _zod.z.string(),
    signedUrl: _zod.z.string().optional()
});
const ExportWorkspaceMeetingsMetadataSchema = _zod.z.object({
    workspaceId: _zod.z.string(),
    filters: _zod.z.record(_zod.z.unknown()).optional(),
    timezone: _zod.z.string(),
    signedUrl: _zod.z.string().optional()
});
const GenerateReviewCycleInsightsMetadataSchema = _zod.z.object({
    reviewCycleId: _zod.z.string(),
    promptHash: _zod.z.string(),
    parentLogId: _zod.z.string(),
    retry: _zod.z.boolean()
});
const getMetadataSchemaForTask = (taskName)=>{
    switch(taskName){
        case _model.ASYNC_TASK_NAMES.EXPORT_COMPANY_MEETINGS_CSV:
            return ExportCompanyMeetingsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.EXPORT_WORKSPACE_MEETINGS_CSV:
            return ExportWorkspaceMeetingsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.GENERATE_REVIEW_CYCLE_INSIGHTS:
            return GenerateReviewCycleInsightsMetadataSchema;
        default:
            // Exhaustiveness check
            const _exhaustive = taskName;
            throw new Error(`Unknown task name: ${_exhaustive}`);
    }
};
